<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="container-fluid all-apps">
  <div *ngIf="loading && !appList" class="spinner-container">
    <mat-progress-spinner [color]="'warning'" [diameter]="50" [mode]="'indeterminate'"> </mat-progress-spinner>
    <small>Loading data...</small>
  </div>

  <ng-container *ngIf="appList && !errorMessage">
    <!-- Favorite Apps Section -->
    <div *ngIf="appList.favoriteApps.length > 0" class="row group-title">
      <div class="col">Favorite Apps</div>
    </div>
    <div *ngIf="appList.favoriteApps.length > 0" class="row">
      <div class="col">
        <div class="apps-wrapper">
          <wsn-app-item *ngFor="let item of appList.favoriteApps" [item]="item"></wsn-app-item>
        </div>
      </div>
    </div>

    <!-- Third Party Apps Section -->
    <div class="row group-title">
      <div class="col">Third Party Apps</div>
    </div>
    <div class="row">
      <div class="col">
        <div class="apps-wrapper">
          <ng-container *ngFor="let item of appList.thirdPartyApps">
            <wsn-app-item *ngIf="!isFavorite(item.id)" [item]="item"></wsn-app-item>
          </ng-container>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="errorMessage" class="error-container">
    {{ errorMessage }}
  </div>
</div>
